import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import DailyPlayersAtRisk from '../DailyPlayersAtRisk/DailyPlayersAtRisk';
import Preloader from '../../Preloader/Preloader';
import { colors } from '../Team';

export default function DailyPlayersAtRiskContainer(props) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  let history = useHistory();

  // useEffect(async () => {
  //         const teamData = await fetchTeamData(history, setLoading);
  //         setData(teamData);
  //     }
  //     , []);

  useEffect(() => {
    function handleEvent(message) {
      setData(message.data);
      setLoading(false);
    }

    setLoading(true);

    window.addEventListener('message', handleEvent);

    return () => window.removeEventListener('message', handleEvent);
  }, []);

  return (
    <>
      <DailyPlayersAtRisk {...data} colors={{ ...colors }} isSidebarCollapsed={true} background={true} />
    </>
  );
}
